import * as Yup from "yup";

const currentYear = new Date().getFullYear();

export default Yup.object({
  month: Yup.number()
    .required("Month is required")
    .min(1, "Invalid month")
    .max(12, "Invalid month"),
  year: Yup.number()
    .required("Year is required")
    .min(2000, "Year must be 2000 or later")
    .max(currentYear + 5, `Year must be ${currentYear + 5} or earlier`),
});
